<template>
	<div v-if="showAnyPromos" class="special-offer-container">
		<!-- Special Offers Top Section -->
		<div class="special-offer-title">
			<div class="price-tag" :style="iconStyle">
				<i :class="`fa fa-${icon}`" aria-hidden="true"></i>
			</div>
			<span :style="titleStyles">{{ titleDefault }}</span>
			<button v-if="allPromos.length > 1" class="show-hide" @click="toggleAllOffers">
				<div class="red-circle-amount">
					{{ allPromos.length }}
				</div>
				<div class="link-blue">
					{{ showHideText }} Offers
				</div>
				<i :class="`fa fa-chevron-${iconHideShow}`"></i>
			</button>
		</div>
		<!-- Promo Offers Section -->
		<promo-box
			:class="{'always-show' : index < unhidableAmount}"
			v-for="(promo, index) in allPromos"
			:key="index"
			v-show="showAllOffers"
			:promo="promo"
		/>
		<!-- Show or Hide all offfers btn -->
		<button
			v-if="allPromos.length > 1"
			class="expandable-others"
			@click="toggleAllOffers"
		>
			<i :class="`fa fa-chevron-${iconHideShow}`"></i>
			{{ showHideText }} Offers
			<i :class="`fa fa-chevron-${iconHideShow}`"></i>
		</button>
	</div>
</template>

<script>
import PromoBox from '../../components/PromoBox.vue';
export default {
	name: 'ProductPromos',
	props: {
		icon: {
			type: String,
			default: 'tag'
		},
		titleColor: {
			type: String,
			default: '#666666'
		},
		renderLimit: {
			type: Number,
			default: 5
		},
		iconColor: {
			type: String,
			default: '#fff'
		},
		iconBackground: {
			type: String,
			default: '#CCCCCC'
		},
		unhidableAmount: {
			type: Number,
			default: 1,
		},
	},
	components: { PromoBox },
	computed: {
		product() {
			return this.$store.state.product;
		},
		allPromos() {
			return [...this.promoOffers, ...this.rewardsOffers];
		},
		rewardsOffers() {
			if (this.product.promos.rewardsOffers) {
				return this.product.promos.rewardsOffers.map(promo => ({ ...promo, type: 'rewards' }));
			}

			return [];
		},
		promoOffers() {
			return this.product.promos.promoOffers || [];
		},
		iconHideShow() {
			return this.showAllOffers ? 'up' : 'down';
		},
		showHideText() {
			return this.showAllOffers ? 'Less' : 'More';
		},
		iconStyle() {
			return `
					color: ${this.iconColor};
					background-color: ${this.iconBackground};
				`;
		},
		titleStyles() {
			return `color: ${this.titleColor};`;
		},
		titleDefault() {
			return this.allPromos.length > 1
				? 'Special Offers Available'
				: 'Special Offer Available';
		},
		showAnyPromos() {
			return this.allPromos.length > 0;
		},
	},
	data() {
		return {
			showAllOffers: false,
		};
	},
	methods: {
		toggleAllOffers() {
			this.showAllOffers = !this.showAllOffers;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';
.special-offer-container {
	margin-top: 15px;
	border-top: 1px solid #CCCCCC;
	position: relative;
	overflow: hidden;
}
.special-offer-title {
	display: flex;
	span {
		margin-left: 30px;
		padding: 10px;
		font-size: 16px;
	}
	.show-hide {
		.button-reset();
		position: absolute;
		display: flex;
		right: 0;
		top: 10px;
		cursor: pointer;
		font-size: 1rem;
		.red-circle-amount {
			background-color: #B12F31;
			border-radius: 15px;
			color: #fff;
			font-size: 14px;
			font-weight: bold;
			padding: 3px 6px;
		}
		.link-blue {
			color: #014A77;
			text-decoration: underline;
			margin: 0 8px;
		}
		.fa {
			color: #014A77;
		}
	}
}
.promos-contaier {
	margin-left: 20px;
}
.price-tag {
	overflow: hidden;
	width: 60px;
	height: 60px;
	position: absolute;
	top: -30px;
	left: -30px;
	border-radius: 50%;
	.fa-tag {
		padding: 32px;
		font-size: 22px;
		transform: rotate(90deg);
	}
}
.noselect {
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.expandable-others {
	.button-reset();
	width: 100%;
	display: block;
	border: 2px solid #E5E5E5;
	border-radius: 0 0 5px 5px;
	padding: 10px;
	text-align: center;
	color: #014A77;
	font-weight: bold;
	font-size: 1rem;
	cursor: pointer;
	.fa {
		color: #C3C3C3;
		font-weight: lighter;
	}
}
.always-show {
	display: block!important;
}
@media screen and (max-width: @mobile) {
	.special-offer-title {
		span {
			font-size: 14px;
		}
	}
}
</style>